import { Injectable } from '@angular/core';
import { GlobalConstants } from '@globalConstants';
import { IAppState } from '@myStore/app.state';
import { selectTheme } from '@myStore/theme/theme.selector';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UIThemeService {
  constructor(private _store: Store<IAppState>) {}

  purpleDarkThemeFieldPanel(): Observable<string> {
    return this._store.pipe(
      select(selectTheme),
      map(theme => {
        if (theme === GlobalConstants.UIThemes.dark) {
          return 'purple-dark-panel-field';
        }

        return '';
      })
    );
  }
}
